var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.488,
    viewBox: "0 0 14.488 14.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{color:#000000;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-434.231 -457.832)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.869,489.046a5.952,5.952,0,1,0,1.744,4.212A5.958,5.958,0,0,0,473.869,489.046ZM470.3,497.19h-1.288v-5.329H470.3Zm0-6.576h-1.288v-1.288H470.3Z",
    transform: "translate(-28.182 -28.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.595,459.956a7.238,7.238,0,1,0,2.124,5.12A7.25,7.25,0,0,0,446.595,459.956Zm-.91,9.33a5.952,5.952,0,1,1,1.746-4.21A5.966,5.966,0,0,1,445.685,469.286Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.288,
    height: 5.329,
    transform: "translate(440.831 463.679)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.288,
    height: 1.288,
    transform: "translate(440.831 461.144)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/info.icon.cd72b8498394e0328ab36dc046911357.svg";
export { ForwardRef as ReactComponent };